import {combineReducers} from "redux";
import {connectRouter} from "connected-react-router";
import authenticityToken from "../ducks/authenticity-token";
import isAdmin from "../ducks/is-admin";
import url from "../ducks/url";
import content from "../ducks/content";
import menu from "../ducks/menu";
import locationData from "../ducks/location-data";
import breadcrumbs from "../ducks/breadcrumbs";
import serviceModal from "../ducks/service-modal";
import onPlatform from "../ducks/onPlatform";
import {reducer as form} from "redux-form";

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    authenticityToken,
    url,
    isAdmin,
    content,
    menu,
    locationData,
    breadcrumbs,
    form,
    serviceModal,
    onPlatform,
    currency: (state = {}) => state,
    isMobile: (state = false) => state,
  });

export default createRootReducer;
